import { render, staticRenderFns } from "./pellets-sackware-lose-ware-vergleich.vue?vue&type=template&id=53c48d30&scoped=true"
import script from "./pellets-sackware-lose-ware-vergleich.vue?vue&type=script&lang=ts"
export * from "./pellets-sackware-lose-ware-vergleich.vue?vue&type=script&lang=ts"
import style0 from "./pellets-sackware-lose-ware-vergleich.vue?vue&type=style&index=0&id=53c48d30&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c48d30",
  null
  
)

export default component.exports